// import { readCache } from '@/store/action';
// import type { GetUserMeResponse, GetStateResponse } from '@/client';
// import { getUserMeQueryKey, getStateQueryKey } from '@/client/@tanstack/react-query.gen';

// export const getUserInfo = () => { //Read userInfo cache
// 	const data = readCache(getUserMeQueryKey()) as GetUserMeResponse
// 	return data
// }
// export const getUserState = () => { //Read user state cache
// 	const data = readCache(getStateQueryKey()) as GetStateResponse
// 	return data
// }
import { readCache } from '@/store/action';
import type { User } from '@/@types/apiType';

export const getUserInfo = () => {
	//Read userInfo cache
	const data = readCache(['get', '/api/user/get', {}]) as User;
	return data;
};
